import { connect } from "react-redux"
import React, { Component } from "react"

import type { Role } from "../../types/types"
import { evidenceListRequest } from "../../actions/evidence-actions"
import EvidenceListItem from "./EvidenceListItem"

type Props = {
    roles: Array<Role>,
    stakeholderID: string,
    evidence: Object,
    getEvidence: (string, string) => void,
}

type State = {
    currentRoleIndex: number,
    canSelectPrevious: boolean,
    canSelectNext: boolean,
}

export class StakeholderEvidencePager extends Component<Props, State> {
    state = {
        currentRoleIndex: 0,
        canSelectPrevious: false,
        canSelectNext: true,
    }

    componentDidMount() {
        this.props.getEvidence(this.props.roles[0].id, this.props.stakeholderID)
    }

    onSelectPrevious = () => {
        if (this.state.canSelectPrevious) {
            const newCurrentRoleIndex = this.state.currentRoleIndex - 1
            const isFirst = newCurrentRoleIndex === 0

            this.setState({
                currentRoleIndex: newCurrentRoleIndex,
                canSelectPrevious: !isFirst,
                canSelectNext: isFirst,
            })
        }
    }

    onSelectNext = () => {
        if (this.state.canSelectNext) {
            const newCurrentRoleIndex = this.state.currentRoleIndex + 1
            const isLast = newCurrentRoleIndex === this.props.roles.length - 1

            this.setState({
                currentRoleIndex: newCurrentRoleIndex,
                canSelectPrevious: isLast,
                canSelectNext: !isLast,
            })
        }
    }

    render() {
        const { roles, evidence } = this.props

        const {
            currentRoleIndex,
            canSelectPrevious,
            canSelectNext,
        } = this.state

        const currentRoleEvidence = evidence[currentRoleIndex]

        return (
            <div id="dimension-title" className="stakeholder-pager-block">
                <div className="stakeholder-pager-container">
                    <div className="tags stakeholder-pager-tags">
                        <div className="tag-item blue">
                            {roles[currentRoleIndex].name}
                        </div>
                    </div>

                    <div>
                        {roles.length > 1 && [
                            <i
                                key="left"
                                className={`fa fa-chevron-left ${
                                    canSelectPrevious
                                        ? "stakeholder-chevron-active"
                                        : "stakeholder-chevron-inactive"
                                }`}
                                onClick={this.onSelectPrevious}
                            />,
                            <i
                                key="right"
                                className={`fa fa-chevron-right ${
                                    canSelectNext
                                        ? "stakeholder-chevron-active"
                                        : "stakeholder-chevron-inactive"
                                }`}
                                onClick={this.onSelectNext}
                            />,
                        ]}
                    </div>
                </div>
                {currentRoleEvidence.map((item) => (
                    <EvidenceListItem
                        item={item}
                        isEditMode={false}
                        key={item.id}
                    />
                ))}
            </div>
        )
    }
}

const mapStateToProps = ({ presentation: { evidence } }, { roles }) => ({
    evidence: Object.keys(evidence)
        .filter((roleID) => roles.find((role) => role.id === roleID))
        .reduce(
            (accumulator, currentRoleID) => [
                ...accumulator,
                evidence[currentRoleID].view,
            ],
            []
        ),
})

const mapDispatchToProps = (dispatch) => ({
    getEvidence: (roleID, stakeholderID) =>
        dispatch(evidenceListRequest(roleID, stakeholderID)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StakeholderEvidencePager)
